import { cn as e } from "../../shared/utils.js";
import { useTranslation as t } from "../../i18n/hooks.js";
import { TimeField as n } from "../primitive/time-field.js";
import { transformSioTimePartToDatePicker as r } from "../utils/transform-sio-date-format-to-date-picker.js";
import { generatePlaceholderFromFormat as i } from "./utils/generate-placeholder-from-format.js";
import { transformDateToSeconds as a, transformSecondsToDate as o } from "./utils/time-picker-utils.js";
import { useState as s } from "react";
import { jsx as c } from "react/jsx-runtime";
import l from "react-datepicker";
//#region src/date-picker/time-picker/time-picker.tsx
var u = "HH:mm";
function d({ disabled: d, error: f, isPreFetching: p, label: m, size: h, seconds: g, userTimeFormat: _, containerClassName: v, wrapperClassName: y, inputClassName: b, onChangeSeconds: x }) {
	let { t: S } = t(), [C, w] = s(!1), T = _ ? r(_) : u;
	return /* @__PURE__ */ c("div", {
		className: e("w-min", v),
		children: /* @__PURE__ */ c(l, {
			calendarClassName: "datepicker--time-only",
			customInput: /* @__PURE__ */ c(n, {
				disabled: d || p,
				error: f,
				focus: C,
				label: m,
				size: h,
				wrapperClassName: e("w-32", b),
				placeholder: i(T)
			}),
			dateFormat: T,
			disabled: d || p,
			onCalendarClose: () => {
				w(!1);
			},
			onCalendarOpen: () => {
				w(!0);
			},
			onChange: (e) => {
				e instanceof Date && x(a(e));
			},
			placeholderText: i(T),
			selected: typeof g == "number" ? o(g) : null,
			showPopperArrow: !1,
			showTimeSelect: !0,
			showTimeSelectOnly: !0,
			timeCaption: S("public_pages_purchase.date_picker.time"),
			timeFormat: T,
			timeIntervals: 15,
			wrapperClassName: y
		})
	});
}
//#endregion
export { d as TimePicker };
